import i18n from './i18n';
// validate语言本地化
import { localize } from 'vee-validate';
localize({ en: i18n.t("$validate") });
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
// 安装所有vee-validate ruls
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
// with typescript
for (let [rule, validation] of Object.entries(rules)) {
    extend(rule, { ...validation });
}
// 自定义规则
// table用required，不指定控件名称
extend("trequired", {
    ...rules.required,
    message: i18n.t("$validate.messages.trequired"),
}
);
// json
extend("json", {
    validate: (value) => {
        try {
            JSON.parse(value);
            return true;
        } catch (e) {
            return false;
        }
    },
});
// mobile
extend("mobile", {
    validate: (value) => {
        return /^[\d-]+$/.test(value);
    },
});
// equal
extend("equal", {
    validate: (value, _a) => {
        return _a.equal == value;
    },
    params: [{
        name: 'equal',
    }]
});
// 倍数
var validate$multiple = function (value, _a) {
    var multiple = _a.multiple;
    if (value === null || value === undefined || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(function (val) { return validate$multiple(val, { multiple: multiple }); });
    }
    var _mod = '' + multiple;
    var _pos = _mod.indexOf('.');
    if (_pos >= 0) {
        var _pow = _mod.length - _pos;
        var _integerRate = parseInt(Math.pow(10, _pow));
        return parseInt((Number(value) * _integerRate).toFixed(0)) % parseInt(multiple * _integerRate) == 0;
    } else {
        return Number(value) % multiple == 0;
    }
};
extend("multiple", {
    validate: validate$multiple,
    params: [{
        name: 'multiple',
        cast: function (value) {
            return Number(value);
        }
    }]
});

// sub_num
extend("sub_num", {
    validate: (value, _a) => {
        return _a.sub_num <= value;
    },
    params: [{
        name: 'sub_num',
    }]
});
var validate$moreThan = function (value, _a) {
    var min = _a.min;
    if (value === null || value === undefined || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(function (val) { return validate$moreThan(val, { min: min }); });
    }
    return Number(value) > min;
};

// 大于
extend('moreThan', {
    validate: validate$moreThan,
    params: ['min'],
    message:'请输入大于{min}的数字'
});

var validate$lessThan = function (value, _a) {
    var max = _a.max;
    if (value === null || value === undefined || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(function (val) { return validate$lessThan(val, { max: max }); });
    }
    return Number(value) < max;
};
// 小于
extend('lessThan', {
    validate: validate$lessThan,
    params: ['max'],
    message:'请输入小于{max}的数字'
});
